import rootStore from '../RootStore';
import { StoreName } from '../StoreName';
/** Get Keycloak store helper function */

var getKeycloakStore = function getKeycloakStore() {
  return rootStore.getStore(StoreName.Keycloak);
};

export { getKeycloakStore };